import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import { rem } from 'polished';
import { ColorSelectTemplate } from './ColorSelectTemplate';

export const ColorSelectStyled = styled(ColorSelectTemplate)`
    padding: ${rem(48)} 0;
    position: relative;

    .sectionTitle {
        margin-bottom: 0;
    }

    .react-multiple-carousel__arrow {
        &--right,
        &--left {
            border-radius: 0;
            margin-bottom: ${rem(4)};

            &:hover {
                opacity: 1;
            }
        }
    }

    .tooltip {
        display: none;
        color: ${({ theme }) => theme.colors.white};
        background: ${({ theme }) => theme.colors.black};
        border: 1px solid transparent;
        position: absolute;
        border-radius: ${rem(3)};
        font-size: ${rem(13)};
        padding: ${rem(8)} ${rem(21)};
        pointer-events: none;
        transition: opacity 0.3s ease-out;
        z-index: 999;
        width: ${rem(270)};
        left: ${rem(-120)};
        top: ${rem(27)};
        text-align: center;
        &:after {
            content: '';
            width: 0;
            height: 0;
            position: absolute;
            border-left: ${rem(8)} solid transparent;
            border-right: ${rem(8)} solid transparent;
            top: ${rem(-6)};
            left: 55%;
            margin-left: ${rem(-8)};
            border-bottom-color: ${({ theme }) => theme.colors.black};
            border-bottom-style: solid;
            border-bottom-width: ${rem(6)};
        }
    }

    .title {
        color: ${({ theme }) => theme.colors.black};
        display: block;
        font-size: ${({ theme }) => theme.fontSizes.textBig};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
    }

    .scrollButtonRight,
    .scrollButtonLeft {
        position: absolute;
        top: ${rem(25)};
        cursor: pointer;

        svg {
            path {
                fill: ${({ theme }) => theme.colors.black};
            }
        }
    }

    .scrollButtonRight {
        right: 0;
    }

    .scrollButtonLeft {
        left: 0;
    }

    .name {
        display: block;
        font-size: ${({ theme }) => theme.fontSizes.textSupBase};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
    }

    .price {
        display: block;
        padding: ${rem(5)} 0;
        font-size: ${({ theme }) => theme.fontSizes.textBase};
    }

    .carImage {
        width: 100%;

        @media (min-width: ${breakpoints.md}px) {
            display: none;
        }
    }

    .colors {
        position: relative;
    }

    .color-item-wrapper {
        margin: ${rem(10)} 0 ${rem(15)} 0;
        padding: ${rem(15)} ${rem(3)};
    }

    .disabled {
        &:hover {
            .tooltip {
                display: block;
            }
        }
    }

    .colorButton {
        min-width: ${rem(55)};
        height: ${rem(55)};
        display: inline-block;
        margin-right: ${rem(10)};
        border-radius: 50%;
        cursor: pointer;
        border: none;
        background-size: cover;

        &.is-selected {
            border: 0.25rem solid ${({ theme }) => theme.colors.white};
            box-shadow: 0px 0px 0px 0.15rem ${({ theme }) => theme.colors.primary};
            text-align: center;
        }

        &.disabled {
            opacity: 0.5;
            pointer-events: none;
        }

        &.enabled {
            &:hover,
            &:focus-visible {
                border: 0.25rem solid ${({ theme }) => theme.colors.white};
                box-shadow: 0px 0px 0px 0.15rem ${({ theme }) => theme.colors.primary};
            }
        }
    }

    .react-multiple-carousel__arrow {
        display: none;
        &::before {
            font-family: revicons-override !important;
        }
    }

    .react-multi-carousel {
        &-item {
            min-width: ${rem(60)};
            &:hover {
                z-index: 2;
            }
            &:last-child {
                .tooltip {
                    left: ${rem(-180)};
                    &:after {
                        left: 77%;
                    }
                }
            }
        }
        &-list {
            &::after,
            &::before {
                content: ' ';
                display: block;
                width: ${rem(40)};
                background-image: linear-gradient(to right, rgba(255, 255, 255, 0), #fff);
                height: 100%;
                position: absolute;
                right: ${rem(-1)};
                z-index: 1;
            }

            &::before {
                background-image: linear-gradient(to left, rgba(255, 255, 255, 0), #fff);
                left: ${rem(-1)};
                display: none;
            }
        }
    }

    @media (min-width: ${breakpoints.md}px) {
        .react-multi-carousel-list {
            &:hover {
                .react-multiple-carousel__arrow {
                    display: block;
                }
            }
        }
        .moved .react-multi-carousel-list {
            &::before {
                display: block;
            }
            &::after {
                display: none;
            }
        }
    }
`;
